import { render, staticRenderFns } from "./PersonalInfoTab.vue?vue&type=template&id=5fe15f0c"
import script from "./PersonalInfoTab.vue?vue&type=script&lang=js"
export * from "./PersonalInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports